import script from "./WhatsAppWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatsAppWidget.vue?vue&type=script&setup=true&lang=js"

import "./WhatsAppWidget.vue?vue&type=style&index=0&id=cdb53d3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb53d3a"]])

export default __exports__